import Card from '@mui/material/Card';
import { SxProps, Theme, useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface SharedTabCardProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export default function SharedTabContentCard({
  children,
  sx,
}: SharedTabCardProps) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        p: 2,
        flexGrow: 1,
        border:
          theme.palette.mode == 'dark'
            ? `0.5px solid ${theme.palette.semantic.outline.light}`
            : 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        boxShadow: `0 1px 6px 0 ${theme.palette.semantic.boxShadow}`,
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}
